<template>
  <div>
    <Topnav title="TRANSCRIPT"></Topnav>
    <Sidebar></Sidebar>
    <div class="content-wrapper" style="background: white">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        loader="dots"
        :is-full-page="fullPage"
        :height="height"
        :width="width"
        background-color="#6b6969"
      ></loading>
      <div class="content-header">
        <div class="custom-container-fluid">
          <div class="row">
            <div class="col-md-12 table-responsive">
              <table class="table">
                <thead>
                  <tr style="">
                    <th class="border-0" colspan="2">
                      <h3>Date : {{ current_date }}</h3>
                      <h4 style="color: #727272;">{{fullname }}</h4>
                    </th>

                    <th class="border-0">
                      <h5 style="color: #727272;">Candidate No.: {{$store.state.userInfo.id}}</h5>
                    </th>
                    <!-- <th class="border-0"></th> -->
                  </tr>
                </thead>
                <thead>
                  <tr style="background: #ee570c; color: white">
                    <th class="border-0">Module</th>
                    <th class="border-0">Score</th>
                    <th class="border-0">Grade</th>
                    <!-- <th class="border-0"></th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(t,i) in transcript" :key="i">
                    <td class="border-left" :class="[i===transcript.length-1?'border-bottom':'']" style="width: 30%">{{ t.title }}</td>
                    <td style="width: 20%" :class="[i===transcript.length-1?'border-bottom':'']">{{t.score}}</td>
                    <td style="width: 20%" class="border-right" :class="[i===transcript.length-1?'border-bottom':'']">
                      <span class="badge" :class="[t.grade ==='fail'?'badge-danger':t.grade ==='platinum'?'badge-platinum':t.grade ==='gold'?'badge-gold':t.grade ==='silver'?'badge-silver':t.grade ==='bronze'?'badge-bronze':'badge-info']"
                        >{{ t.grade }}</span
                      >
                    </td>
                    <td style="border: none !important; width: 20%" :class="[i===transcript.length-1?'border-bottom':'']">
                      <div v-if="t.grade !=='fail' && t.grade !=='N/A'">
                        <i class="fa fa-file mr-2" />
                        <span class="text-green text-uppercase"
                        >download certificate</span
                        >
                      </div>
                      <div v-else>
                        N/A
                      </div>
                    </td>
                  </tr>
<!--                  <tr>-->
<!--                    <td class="border-left">Module 2</td>-->
<!--                    <td>90%</td>-->
<!--                    <td class="border-right">-->
<!--                      <span class="badge badge-warning">Gold</span>-->
<!--                    </td>-->
<!--                    <td style="border: none !important">-->
<!--                      <i class="fa fa-file mr-2" />-->
<!--                      <span class="text-green text-uppercase"-->
<!--                        >download certificate</span-->
<!--                      >-->
<!--                    </td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <td class="border-left">Module 3</td>-->
<!--                    <td>72%</td>-->
<!--                    <td class="border-right">-->
<!--                      <span class="badge" style="background: #8c5634"-->
<!--                        >Bronze</span-->
<!--                      >-->
<!--                    </td>-->
<!--                    <td class="border-right" style="border: none !important">-->
<!--                      <i class="fa fa-file mr-2" />-->
<!--                      <span class="text-green text-uppercase"-->
<!--                        >download certificate</span-->
<!--                      >-->
<!--                    </td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <td class="border-left border-bottom">Module 4</td>-->
<!--                    <td class="border-bottom">85%</td>-->
<!--                    <td class="border-bottom border-right">-->
<!--                      <span class="badge">Silver</span>-->
<!--                    </td>-->
<!--                    <td class="border-bottom" style="border: none !important">-->
<!--                      <i class="fa fa-file mr-2" />-->
<!--                      <span class="text-green text-uppercase"-->
<!--                        >download certificate</span-->
<!--                      >-->
<!--                    </td>-->
<!--                  </tr>-->
                </tbody>
              </table>
            </div>
            <div class="col-md-12">
              <h5>Achievements</h5>
            </div>
            <div class="col-md-2">
              <div
                class="card"
                style="
                  box-shadow: none;
                  border: 1px solid #059ca6;
                  background: #f2feff;
                "
              >
                <div class="card-body">
                  <div class="row">
                    <div class="col-7">
                      <h4>Overrall</h4>
                      <h2>{{over_all+'%'}}</h2>
                    </div>
                    <div class="col-2">
                      <img
                        src="@/assets/badge-silver.png"
                        style="height: 120px"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
<!--            <div class="col-md-2">-->
<!--              <div-->
<!--                class="card"-->
<!--                style="-->
<!--                  box-shadow: none;-->
<!--                  border: 1px solid #059ca6;-->
<!--                  background: #f2feff;-->
<!--                "-->
<!--              >-->
<!--                <div class="card-body">-->
<!--                  <div class="row">-->
<!--                    <div class="col-md-12">-->
<!--                      <h4>Cohort</h4>-->
<!--                      <div class="mt-4 mb-2">-->
<!--                        <img src="@/assets/check_mark.png" alt="" /><span-->
<!--                          style="-->
<!--                            font-size: 25px;-->
<!--                            font-weight: bold;-->
<!--                            vertical-align: middle;-->
<!--                            font-size: 1.8rem;-->
<!--                            font-family: var(&#45;&#45;gothamMedium);-->
<!--                          "-->
<!--                        >-->
<!--                          Top 3 %</span-->
<!--                        >-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Company-Jobs",
  data() {
    return {
      jobs: [],
      isLoading: false,
      fullPage: true,
      height: 128,
      width: 128,
      transcript:[],
      over_all:0
    };
  },
  computed:{
    fullname(){
      return this.$store.state.userInfo.first_name+' '+ this.$store.state.userInfo.last_name;
    },
    current_date(){
      return moment().format('DD/MM/YYYY')
    }
  },
  components: {
    Loading: () => import("vue-loading-overlay"),
    Sidebar: () => import("@/components/Dashboard-sidebar"),
    // foot: () => import('@/components/footer_component'),
    Topnav: () => import("@/components/Dashboard-topnav"),
  },
  methods: {
    getTranscript() {
      this.isLoading = true;
      axios.get(`${process.env.VUE_APP_BASE_URL}/transcript/${this.$store.state.userInfo.id}`).then((res) => {
        console.log(res.data)
        this.transcript =res.data.data.data;
        this.over_all = res.data.data.over_all;

      }).catch((err) => {
      }).finally(() => {
          this.isLoading = false
      })
    },
    formatdate(date) {
      return date ? moment(date).format("dddd, MMMM D, YYYY") : "";
    },

  },
  async created() {
    window.$(".index-page").removeClass("sidebar-open");
    setTimeout(() => {
      window.$(".nav-link").removeClass("active");
      window.$("#transcript").addClass("active");
    }, 100);

    this.getTranscript();

    this.$loadScript("/assets/js/plugins/moment.min.js")
        .then(() => {
        })
        .catch(() => {
        });
  },
};
</script>
<!--<style src="https://cdn.datatables.net/select/1.3.2/css/select.dataTables.min.css"></style>-->
<style scoped>
.badge-bronze{
  background: #8C5634;
  color:white;
}

.badge-silver{
  background: #C0C0C0;
  color:white;
}

.badge-platinum{
  background: #727272;
  color:#06192B;
}
.badge-gold{
  background: #E9D735;
  color:#06192B;
}
/*table.dataTable tr th.select-checkbox.selected::after {*/
/*content: "✔";*/
/*margin-top: -11px;*/
/*margin-left: -4px;*/
/*text-align: center;*/
/*text-shadow: rgb(176, 190, 217) 1px 1px, rgb(176, 190, 217) -1px -1px, rgb(176, 190, 217) 1px -1px, rgb(176, 190, 217) -1px 1px;*/
/*}*/

table.dataTable tbody > tr.selected,
table.dataTable tbody > tr > .selected {
  background-color: #b0bed9;
}

table.dataTable.stripe tbody > tr.odd.selected,
table.dataTable.stripe tbody > tr.odd > .selected,
table.dataTable.display tbody > tr.odd.selected,
table.dataTable.display tbody > tr.odd > .selected {
  background-color: #acbad4;
}

table.dataTable.hover tbody > tr.selected:hover,
table.dataTable.hover tbody > tr > .selected:hover,
table.dataTable.display tbody > tr.selected:hover,
table.dataTable.display tbody > tr > .selected:hover {
  background-color: #aab7d1;
}

table.dataTable.order-column tbody > tr.selected > .sorting_1,
table.dataTable.order-column tbody > tr.selected > .sorting_2,
table.dataTable.order-column tbody > tr.selected > .sorting_3,
table.dataTable.order-column tbody > tr > .selected,
table.dataTable.display tbody > tr.selected > .sorting_1,
table.dataTable.display tbody > tr.selected > .sorting_2,
table.dataTable.display tbody > tr.selected > .sorting_3,
table.dataTable.display tbody > tr > .selected {
  background-color: #acbad5;
}

table.dataTable.display tbody > tr.odd.selected > .sorting_1,
table.dataTable.order-column.stripe tbody > tr.odd.selected > .sorting_1 {
  background-color: #a6b4cd;
}

table.dataTable.display tbody > tr.odd.selected > .sorting_2,
table.dataTable.order-column.stripe tbody > tr.odd.selected > .sorting_2 {
  background-color: #a8b5cf;
}

table.dataTable.display tbody > tr.odd.selected > .sorting_3,
table.dataTable.order-column.stripe tbody > tr.odd.selected > .sorting_3 {
  background-color: #a9b7d1;
}

table.dataTable.display tbody > tr.even.selected > .sorting_1,
table.dataTable.order-column.stripe tbody > tr.even.selected > .sorting_1 {
  background-color: #acbad5;
}

table.dataTable.display tbody > tr.even.selected > .sorting_2,
table.dataTable.order-column.stripe tbody > tr.even.selected > .sorting_2 {
  background-color: #aebcd6;
}

table.dataTable.display tbody > tr.even.selected > .sorting_3,
table.dataTable.order-column.stripe tbody > tr.even.selected > .sorting_3 {
  background-color: #afbdd8;
}

table.dataTable.display tbody > tr.odd > .selected,
table.dataTable.order-column.stripe tbody > tr.odd > .selected {
  background-color: #a6b4cd;
}

table.dataTable.display tbody > tr.even > .selected,
table.dataTable.order-column.stripe tbody > tr.even > .selected {
  background-color: #acbad5;
}

table.dataTable.display tbody > tr.selected:hover > .sorting_1,
table.dataTable.order-column.hover tbody > tr.selected:hover > .sorting_1 {
  background-color: #a2aec7;
}

table.dataTable.display tbody > tr.selected:hover > .sorting_2,
table.dataTable.order-column.hover tbody > tr.selected:hover > .sorting_2 {
  background-color: #a3b0c9;
}

table.dataTable.display tbody > tr.selected:hover > .sorting_3,
table.dataTable.order-column.hover tbody > tr.selected:hover > .sorting_3 {
  background-color: #a5b2cb;
}

table.dataTable.display tbody > tr:hover > .selected,
table.dataTable.display tbody > tr > .selected:hover,
table.dataTable.order-column.hover tbody > tr:hover > .selected,
table.dataTable.order-column.hover tbody > tr > .selected:hover {
  background-color: #a2aec7;
}

table.dataTable tbody td.select-checkbox,
table.dataTable tbody th.select-checkbox {
  position: relative;
}

table.dataTable tbody td.select-checkbox:before,
table.dataTable tbody td.select-checkbox:after,
table.dataTable tbody th.select-checkbox:before,
table.dataTable tbody th.select-checkbox:after {
  display: block;
  position: absolute;
  top: 1.2em;
  left: 50%;
  width: 12px;
  height: 12px;
  box-sizing: border-box;
}

table.dataTable tbody td.select-checkbox:before,
table.dataTable tbody th.select-checkbox:before {
  content: " ";
  margin-top: -6px;
  margin-left: -6px;
  border: 1px solid black;
  border-radius: 3px;
}

table.dataTable tr.selected td.select-checkbox:after,
table.dataTable tr.selected th.select-checkbox:after {
  content: "✓";
  font-size: 20px;
  margin-top: -19px;
  margin-left: -6px;
  text-align: center;
  text-shadow: 1px 1px #b0bed9, -1px -1px #b0bed9, 1px -1px #b0bed9,
    -1px 1px #b0bed9;
}

table.dataTable.compact tbody td.select-checkbox:before,
table.dataTable.compact tbody th.select-checkbox:before {
  margin-top: -12px;
}

table.dataTable.compact tr.selected td.select-checkbox:after,
table.dataTable.compact tr.selected th.select-checkbox:after {
  margin-top: -16px;
}

div.dataTables_wrapper span.select-info,
div.dataTables_wrapper span.select-item {
  margin-left: 0.5em;
}

@media screen and (max-width: 640px) {
  div.dataTables_wrapper span.select-info,
  div.dataTables_wrapper span.select-item {
    margin-left: 0;
    display: block;
  }
}
.td:last-child {
  border-right: none !important;
  border-left: none !important;
  padding: 2rem !important;
}

.table-bordered td {
  border-right: none !important;
  border-left: none !important;
  padding: 2rem !important;
}
.table-bordered {
  border-right: none !important;
}
td {
  /* border-left: 1px solid #dee2e6 !important;
  border-bottom: 1px solid #dee2e6 !important;
  border-top: 1px solid #dee2e6 !important; */
  padding: 2rem !important;
}
</style>

<!--<style scoped src="../../../public/assets/css/general-front-css.css"></style>-->
<!--<style src="../../../public/plugins/fontawesome-free/css/all.min.css" scoped></style>-->


